import React from 'react';
import './SwipeHintOverlay.css';

const SwipeHintOverlay = ({ text = "¡Desliza hacia arriba o abajo para ver más productos!", onClose }) => (
    <div className="swipe-hint-overlay">
        <div className="swipe-hint-hand">
            <div className="swipe-hint-finger"></div>
        </div>
        <div className="swipe-hint-text">{text}</div>
        {onClose && (
            <button className="swipe-hint-close" onClick={onClose}>Cerrar</button>
        )}
    </div>
);

export default SwipeHintOverlay; 